import React from "react";
import { ButtonContent } from "../global/boton/ButtonContent";

function HeroSection({ img1, img2, img3, img4, slogan, description }) {

  const imagessliders = [
    img1,
    img2,
    img3,
    img4,
  ];

  return (
    <>
      <div className="pic-wrapper">
        {
          imagessliders.map((img, index) => (
            <figure
              key={index}
              className={`pic-${index + 1}`}
              style={{ background: `url("${img}")` }}
            ></figure>
          ))
        }

        <div className="z-10 relative w-4/5 mx-auto md:h-[100vh] h-[135vh]">
          <div className="w-full h-full pb-[15%] md:pb-[10%] flex flex-col justify-end items-center">
            <h1 className="text-white text-center">
              {slogan}
            </h1>
            <p className="text-white text-center">
              {description}
            </p>
            <div className="flex justify-center md:block">
              <ButtonContent />
            </div>
          </div>
          <div className="w-1/2"></div>
        </div>
      </div>
    </>
  );
}

export default HeroSection;
